exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".glide__inner h1,.glide__slide-box h1{font-family:ToyotaType-Book,sans-serif!important}.glide__inner h1,.glide__inner h2,.glide__slide-box h1,.glide__slide-box h2{color:#282830!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false,"minimize":true,"importLoaders":1,"alias":{"/assets":"/home/vintagt/www/toyota/toyota.com/dreamcar/front/assets","/static":"/home/vintagt/www/toyota/toyota.com/dreamcar/front/static"}}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7e02dcca","scoped":false,"hasInlineConfig":true}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":false}!./node_modules/sass-resources-loader/lib/loader.js?{"resources":["/home/vintagt/www/toyota/toyota.com/dreamcar/front/assets/scss/util/_mixins.scss","/home/vintagt/www/toyota/toyota.com/dreamcar/front/assets/scss/util/_functions.scss","/home/vintagt/www/toyota/toyota.com/dreamcar/front/assets/scss/util/_variables.scss"]}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./components/AppSliderItem.vue
// module id = oC+/
// module chunks = 0 1 2 5 6